import { get, canUseDOM } from './index';
export const getCountryFromContext = () => {
  if (canUseDOM) {
    return get(window, 'current_country', 'IN');
  }
};